// src/components/OutletScope.tsx
import { useMemo } from "react";
import { OutletScopeProvider } from "../context/NovuUIContext.js";
import { OutletStore } from "../context/OutletStore.js";
import { OutletHost } from "./OutletHost.js";
import { jsx, jsxs } from "react/jsx-runtime";
var OutletScope = ({ store, children }) => {
  const outlets = useMemo(() => store ?? new OutletStore(), [store]);
  return /* @__PURE__ */ jsxs(OutletScopeProvider, { value: outlets, children: [
    children,
    /* @__PURE__ */ jsx(OutletHost, { store: outlets })
  ] });
};
export {
  OutletScope
};
//# sourceMappingURL=OutletScope.js.map